import React from 'react';
import { FixedForm } from '../../components/Forms';
import { Title } from '../../components/Text';
import { ActionFormItem } from './ActionFormItem';
import { Button  } from '../../components/Button';
import { Flex } from '../../components/Flex';
import { Scrollbar } from '../../components/Scrollbar';
import { findIndex } from 'lodash';

const ActionForm = ({
    title,
    fields=[],
    values={},
    errors={},
    onClose,
    onValueChange,
    onSave,
    hasChanges,
    width,
    okButtonText,
    validateValue,
    validateValues
}) => {

    const renderField = (field, i) => {
        let isRow = Array.isArray(field),
        item = isRow
            ? field.map((f, ii) => renderField(f, `${i}-${ii}`))
            : field.key !== undefined
                ? (<ActionFormItem
                        lastField={i === fields.length - 1}
                        key={`form-item-${i}`}
                        name={field.key}
                        value={values[field.key]}
                        onValueChange={onValueChange}
                        error={errors[field.key]}
                        isRow={typeof i === "string" && i.includes("-")}
                        validateValue={validateValue}
                        validateValues={validateValues}
                        requiredField={Array.isArray(field.rules) && findIndex(field.rules, { required: true }) > -1}
                        {...field}
                    />)
                : null;

        return isRow
            ? <Flex key={`row-${i}`} justify="space-between" gap={{ right: 8 }} position="relative">{item}</Flex>
            : item;
    };

    return(
        <FixedForm width={width} onClose={onClose}>
            <Title h4 margin={{ bottom: "15px" }}>{title}</Title>
            <Flex height="calc(100% - 107px)">
                <Scrollbar>
                    <Flex direction="column" padding={{ right: "20px" }} gap={{ bottom: 12 }}>
                        {fields.map((field, i) => renderField(field, i))}
                    </Flex>
                </Scrollbar>
            </Flex>
            <Flex justify="flex-end" align="center" gap={{ right: 37 }} margin={{ top: "24px" }}>
                <Button link onClick={() => onClose()}>Cancel</Button>
                <Button disabled={!hasChanges || !Object.values(errors).every(o => o === false)} onClick={() => onSave()}>{okButtonText || title}</Button>
            </Flex>
        </FixedForm>
    );
};

export { ActionForm };